// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*================================================
                Usage Dashboard Page
======================================================*/
.dashboard-ds.usage_db {
  padding-top: 25px;
  padding-bottom: 0px;
}
.usage_db_top_form {
  background: #ffffff;
  padding: 25px;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 15px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.focus-input-label .floating-label select.form-control {
  width: 100%;
  padding: 5px 10px;
  height: 37px;
  border: solid 1px rgba(0, 0, 0, 0.2);
  min-width: initial;
  box-sizing: border-box;
  -webkit-transition: all 0.3s linear;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  font-size: 15px;

  border-radius: 6px;
  outline: 0px;
  box-shadow: none;
}
.usage_db .floating-label .form-control .ant-select-selection--single {
  height: 31px;
  border: 0px;
  top: -4px;
}
.usage_db_top_form .floating-label .btn {
  background: #1b82ec;
  color: #000000;
  
  font-weight: 400;
  font-size: 15px;
  padding: 5px 20px;
}
.usage_db_top_form.focus-input-label .floating-label input.form-control {
  padding: 4px 10px;
  height: 37px;
}
.usage_db_top_form.focus-input-label .floating-label {
  width: 27%;
}
.usage_db_top_form.focus-input-label .floating-label:last-child {
  width: 100px;
}
.usage_db .row-tails .mini-stat-desc h6 {
  font-size: 15px;
}
.usage_db .row-tails .mini-stat-desc h3 {
  font-size: 25px;
}
.usage_db .row-tails .mini-stat-icon {
  margin-right: 20px;
}
.usage_db .row-tails .card-body {
  display: flex;
  position: relative;
  width: 20%;
  padding: 20px 30px;
}
.usage_db .row-tails {
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 15px;
}
.usage_db h4.page-title {
  font-size: 20px;
  margin: 0;
  line-height: 30px;
  color: #333333;
  padding-top: 5px;
  margin-bottom: 10px;
  
}
.usage_db .card.piechart_card img {
  padding: 8px 0px;
}
.apexcharts-legend.apexcharts-align-center.position-right {
  right: 12% !important;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Consultant/UsageDashbord /usagedashboard.css"],"names":[],"mappings":"AAAA;;uDAEuD;AACvD;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,eAAe;;EAEf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,cAAc;;EAEd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;;AAErB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB","sourcesContent":["/*================================================\n                Usage Dashboard Page\n======================================================*/\n.dashboard-ds.usage_db {\n  padding-top: 25px;\n  padding-bottom: 0px;\n}\n.usage_db_top_form {\n  background: #ffffff;\n  padding: 25px;\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 15px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.focus-input-label .floating-label select.form-control {\n  width: 100%;\n  padding: 5px 10px;\n  height: 37px;\n  border: solid 1px rgba(0, 0, 0, 0.2);\n  min-width: initial;\n  box-sizing: border-box;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  color: #000;\n  font-weight: 400;\n  font-size: 15px;\n\n  border-radius: 6px;\n  outline: 0px;\n  box-shadow: none;\n}\n.usage_db .floating-label .form-control .ant-select-selection--single {\n  height: 31px;\n  border: 0px;\n  top: -4px;\n}\n.usage_db_top_form .floating-label .btn {\n  background: #1b82ec;\n  color: #000000;\n  \n  font-weight: 400;\n  font-size: 15px;\n  padding: 5px 20px;\n}\n.usage_db_top_form.focus-input-label .floating-label input.form-control {\n  padding: 4px 10px;\n  height: 37px;\n}\n.usage_db_top_form.focus-input-label .floating-label {\n  width: 27%;\n}\n.usage_db_top_form.focus-input-label .floating-label:last-child {\n  width: 100px;\n}\n.usage_db .row-tails .mini-stat-desc h6 {\n  font-size: 15px;\n}\n.usage_db .row-tails .mini-stat-desc h3 {\n  font-size: 25px;\n}\n.usage_db .row-tails .mini-stat-icon {\n  margin-right: 20px;\n}\n.usage_db .row-tails .card-body {\n  display: flex;\n  position: relative;\n  width: 20%;\n  padding: 20px 30px;\n}\n.usage_db .row-tails {\n  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 15px;\n}\n.usage_db h4.page-title {\n  font-size: 20px;\n  margin: 0;\n  line-height: 30px;\n  color: #333333;\n  padding-top: 5px;\n  margin-bottom: 10px;\n  \n}\n.usage_db .card.piechart_card img {\n  padding: 8px 0px;\n}\n.apexcharts-legend.apexcharts-align-center.position-right {\n  right: 12% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
